<template>
  <div class="entrust_detail">
    <div class="entrust_detail--header">
      <span>{{ $t('委托中') }}</span>
    </div>
    <div class="entrust_title current_title">
      <span class="market title_style">{{ $t('市场') }}</span>
      <span class="time title_style">{{ $t('委托时间') }}</span>
      <span class="side title_style">{{ $t('类别') }}</span>
      <span class="price title_style">{{ $t('委托价') }}</span>
      <span class="number title_style">{{ $t('委托数量') }}</span>
      <span class="freezen title_style">{{ $t('冻结保证金') }}</span>
      <span class="fee title_style">{{ $t('手续费') }}</span>
      <span class="action title_style">{{ $t('操作') }}</span>
    </div>
    <div class="entrust_box">
      <ul v-if="entrustlList.length > 0" class="entrust_ul current_ul">
        <li
          v-for="item in entrustlList"
          :key="item.orderSn"
          class="entrust_li current_li"
        >
          <span class="market content_style">
            {{
              `${item.contractNo.split('_')[0].toUpperCase()} ${item.lever}X`
            }}
          </span>
          <span class="time content_style">
            {{ item.createdDate }}
          </span>

          <span
            class="side content_style"
            :class="{ BULL: 'type_buy', BEAR: 'type_sell' }[item.direction]"
          >
            {{
              { BULL: $t('买入/做多'), BEAR: $t('卖出/做空') }[item.direction]
            }}
          </span>
          <span class="price content_style">{{ item.openPrice }}</span>
          <span class="number content_style">{{ item.amount }}</span>
          <span class="freezen content_style">{{ item.initMargin }}</span>
          <span class="fee content_style">{{ item.openFee }}</span>

          <span class="action content_cancel content_style">
            <span @click="divestmentEvent(item.orderSn)">
              {{ $t('撤单') }}
            </span>
          </span>
        </li>
      </ul>
      <NoData
        v-else
        :sceneType="currentSkin === 'black' ? 'night' : 'day'"
      ></NoData>
    </div>
  </div>
</template>
<script>
import { fetchEntrustList, doCancelEntrust } from '@/api/contract'
import { mapState } from 'vuex'
import EventBus from '@/utils/event-bus'

export default {
  data() {
    return {
      loadingInstance: null,
      shimOrder: '',
      entrustlList: [],
    }
  },
  computed: {
    ...mapState('contract', ['currentSkin', 'contractData']),
    contractNo() {
      return this.contractData.contractNo
    },
  },
  watch: {
    contractNo: {
      handler() {
        this.getEntrustList()
      },
      immediate: true,
    },
  },
  mounted() {
    EventBus.$on('contractTradeSucceed', this.getEntrustList)
  },
  methods: {
    async getEntrustList() {
      this.loadingInstance = this.$loading({
        target: '.entrust_box',
        duration: 0,
        background:
          this.currentSkin === 'black'
            ? 'rgba(19, 22, 37, 1)'
            : 'rgba(255, 255, 255, 1)',
      })
      try {
        const { list } = await fetchEntrustList({
          contractNo: this.contractNo,
          orderStatus: 'WAIT',
        })
        this.entrustlList = list
      } finally {
        this.loadingInstance.close()
      }
    },
    /**
     * @description 撤单
     * @param orderSn 委托ID
     */
    async divestmentEvent(orderSn) {
      const titleText = this.$t('提示')
      const contentText = this.$t('确认撤单？')
      const okText = this.$t('确认')
      const cancelText = this.$t('取消')
      await this.$Modal.confirm({
        okText,
        cancelText,
        title: '',
        render(h) {
          return h('div', {}, [
            h(
              'div',
              {
                attrs: {
                  style:
                    'height:24px;line-height:24px;font-size:16px;color:rgba(0,0,0,0.9);font-weight:600;',
                },
              },
              titleText
            ),
            h(
              'div',
              {
                attrs: {
                  style:
                    'height:42px;line-height:42px;font-size:14px;color:rgba(0,0,0,0.6)',
                },
              },
              contentText
            ),
          ])
        },
        onOk: async () => {
          await doCancelEntrust({ orderSn })
          this.$Message.success(this.$t('操作成功'))
          this.getEntrustList()
        },
      })
    },
  },
}
</script>
<style lang="less" scoped>
// 混入样式
.mixin_list(@market,@time,  @side, @number, @freezen, @fee,@price,@action) {
  .market {
    width: @market;
  }
  .time {
    width: @time;
  }

  .side {
    width: @side;
  }
  .price {
    width: @price;
  }
  .number {
    width: @number;
  }
  .freezen {
    width: @freezen;
  }
  .fee {
    width: @fee;
  }
  .action {
    width: @action;
  }
}
.entrust_detail {
  position: relative;
  min-height: 100%;
  background: @contentBgColor2;
  &--header {
    line-height: 40px;
    padding-left: 52px;
    font-size: 16px;
    font-weight: 500;
    color: #d2d7ec;
    margin-bottom: 10px;
    span {
      display: inline-block;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        height: 2px;
        width: 100%;
        left: 0;
        bottom: 0;
        background: #c02e21;
      }
    }
  }
  .entrust_title {
    margin-top: 4px;
    margin-bottom: 5px;
  }
  .entrust_title,
  .entrust_ul > .entrust_li {
    padding: 0 70px 0 52px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .title_style {
      font-size: 14px;
      font-family: PingFangSC-Medium, 'PingFang SC';
      font-weight: 500;
      color: @textColor2;
      line-height: 20px;
      text-align: center;
    }
    .content_style {
      font-size: 14px;
      font-family: PingFangSC-Medium, 'PingFang SC';
      font-weight: 500;
      color: @textColor3;
      line-height: 20px;
      text-align: center;
    }
    .content_cancel {
      color: rgba(66, 179, 250, 1);
      cursor: pointer;
    }
    .icon_control {
      margin-right: 8px;
    }
    // 动态控制字体颜色
    .type_buy {
      color: rgba(65, 179, 126, 1);
    }
    .type_sell {
      color: rgba(206, 68, 68, 1);
    }
  }
  .history_entrust_box,
  .entrust_box {
    min-height: 240px;
    .entrust_ul {
      padding-bottom: 40px;
      .entrust_li {
        padding-top: 5px;
        padding-bottom: 5px;
      }
      .entrust_li:hover {
        background: @hoverBgColor;
      }
    }
  }

  .current_title,
  .current_ul > .current_li {
    .mixin_list(
      @market: 100px;@time: 12.5%;  @side: 12.5%;
        @number: 12.5%; @freezen: 12.5%; @fee:12.5%;@price: 12.5%;
        @action: 12.5%;
    );
  }
}
</style>
